import React from 'react';
import {
  getSpriteStyles,
  type BaronWuffettGesture,
} from '../../config/avatars';

interface AvatarSpriteProps {
  gesture: BaronWuffettGesture;
  size?: number;
  className?: string;
}

export const AvatarSprite: React.FC<AvatarSpriteProps> = ({
  gesture,
  size = 128,
  className,
}) => {
  const spriteStyles = getSpriteStyles(gesture);

  return (
    <div
      className={className}
      style={{
        width: size,
        height: size,
        ...spriteStyles,
      }}
    />
  );
};
